import { addressService } from '@/services/utils/addressService'
import { parseISO, format } from 'date-fns'
import ptLocale from 'date-fns/locale/pt-BR'

export function getCurrency(value: number) {
  if (!value) return ''

  return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
}

export function getFilterObject(arr: any[], value: string) {
  if (!value) return arr

  if (+value) {
    const filter = arr.filter((o: any) =>
      Object.keys(o).some(
        (k) => typeof o[k] === 'number' && o[k].toString().includes(value)
      )
    )
    return filter
  }

  const filter = arr.filter((o: any) =>
    Object.keys(o).some(
      (k) =>
        typeof o[k] === 'string' &&
        o[k].toLowerCase().includes(value.toLowerCase())
    )
  )
  return filter
}

export function redirectPage(itemToRemove: string, page: string) {
  setTimeout(() => {
    localStorage.removeItem(itemToRemove)
    window.location.href = `/${page}`
  }, 1000)
}

export async function getCitiesByUf(uf: string) {
  const res = await addressService.getCities(uf)
  const cityList = res.data.data
  let arrOfCities: any = []
  res.data.data.forEach((item: any) => {
    arrOfCities.push(item?.nome)
  })
  return { arrOfCities, cityList }
}

export function getParamByParam(
  id: string,
  arr: any[],
  paramFind: string,
  paramReturn: string
) {
  if (!id || !arr?.length || !paramFind || !paramReturn) return ''

  const finder = arr.find((item) => item?.[paramFind] === id)
  return finder?.[paramReturn] ?? ''
}

export function getIdListFiltered(arr: any[]) {
  return arr.map((item: any) => item?.id ?? '').filter((item: any) => item)
}

export const convertionToB64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader?.result?.split(',')[1])
    reader.onerror = (error) => reject(error)
  })

export function countDecimalDigits(n: number) {
  var char_array = n.toString().split('') // split every single char
  var not_decimal = char_array.lastIndexOf('.')
  return not_decimal < 0 ? 0 : char_array.length - not_decimal - 1
}

export function kFormatter(value: number, isCurrency: boolean) {
  const formattedNumber =
    Math.abs(value) > 999
      ? Math.sign(value) * Number((Math.abs(value) / 1000).toFixed(1)) + 'k'
      : Math.sign(value) * Math.abs(value)

  if (isCurrency) {
    return `R$ ${formattedNumber}`
  } else {
    return formattedNumber
  }
}

export function removePropertyEmpty(object: any) {
  const cloneObject = object

  for (const key in cloneObject)
    if (cloneObject[key]?.length === 0) delete cloneObject[key]

  return cloneObject
}

export function DeviceMobile() {
  let hasTouchScreen = false

  if ('maxTouchPoints' in navigator) {
    hasTouchScreen = navigator.maxTouchPoints > 0
  } else if ('msMaxTouchPoints' in navigator) {
    hasTouchScreen = navigator.msMaxTouchPoints > 0
  } else {
    const mQ = matchMedia?.('(pointer:coarse)')
    if (mQ?.media === '(pointer:coarse)') {
      hasTouchScreen = !!mQ.matches
    } else if ('orientation' in window) {
      hasTouchScreen = true
    } else {
      const UA = navigator.userAgent
      hasTouchScreen =
        /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
        /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA)
    }
  }

  return hasTouchScreen
}

function dateToEN(date: string) {
  return date.split('/').reverse().join('-')
}

export function extractDate(date: string) {
  if (!date || date === '--') return
  const [extract] = date.split(' ')
  return dateToEN(extract)
}

export function getDate(type: string, date?: Date) {
  if (!type) return

  const types: any = {
    day: 'E',
    'day-month': 'dd/MM',
    full: 'dd/MM/yyyy'
  }

  return format(date ? new Date(date) : new Date(), types[type], {
    locale: ptLocale
  })
}

export const fillSelectList = (arr: any[], rowsSelecteds: any[]) => {
  const findRowsSelected = arr?.map((item) =>
    rowsSelecteds?.find((el) => el === item?.id || el === item?.avariaId)
  )
  const mounCheckSelects = findRowsSelected?.map((item) => ({
    checked: item ? true : false,
    id: item ?? ''
  }))

  return mounCheckSelects
}

export function isArrEqual(a: any[], b: any[]) {
  if (a instanceof Array && b instanceof Array) {
    if (a.length !== b.length) {
      return false
    }

    for (var i = 0; i < a.length; i++) {
      if (!isArrEqual(a[i], b[i])) {
        return false
      }
    }

    return true
  }

  return a === b
}

export function hasValidValue(obj: any) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key]
      if (!!value?.length) return true
    }
  }
  return false
}

export const applyRedStyle = (text: string) => {
  return <span style={{color: '#F64A14'}}>{text}</span>
}